module.exports = __webpack_public_path__ + "img/nt117-03-81-1.prt.7140605c.jpg";